import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aee3966"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"150px"}
}
const _hoisted_2 = { class: "text-body-2 text-medium-emphasis mb-0" }
const _hoisted_3 = { class: "d-flex align-start ga-2" }
const _hoisted_4 = { class: "text-body-1 font-weight-bold nombre flex-grow-1" }
const _hoisted_5 = { class: "text-caption text-medium-emphasis" }
const _hoisted_6 = {
  key: 2,
  class: "text-center mt-2"
}

import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { TorneoPropioDTO } from "@/interfaces/Torneo";
import { deleteTorneo, getTorneosCreadosUsuario } from "@/services/TorneosService";
import { useAuth } from "@/composables/useAuth";
import { useToast } from "@/composables/useToast";
import { FORMATO_COPA, esPorJornadas, nombreEvento, textosEvento } from "@/Constant/FormatoTorneo";
import { tipoTorneoOptions } from "@/Constant/TiposTorneo";
import { diaDeHoy, formatFechaSpaWhitoutAsync, ultimoDiaEvento } from "@/utils/Fecha";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import ModalCrearTorneo from "@/components/GestionTorneos/ModalCrearTorneo.vue";

const TANDA = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'GestionTorneosView',
  setup(__props) {

const router = useRouter();
const { getidUsuario } = useAuth();
const { triggerToast } = useToast();
const idUsuario = parseInt(getidUsuario.value);

const isLoading = ref(true);
const eventos = ref<TorneoPropioDTO[]>([]);
const vista = ref<"proximos" | "terminados">("proximos");
const cuantosVer = ref(TANDA);
const crear = ref(false);

// Las fechas, como en Mis eventos: un evento termina el día que acaba
const primerDia = (e: TorneoPropioDTO) => (e.fechaInicioTorneo ?? e.fechaFinTorneo ?? "").slice(0, 10);
const ultimoDia = (e: TorneoPropioDTO) => ultimoDiaEvento(primerDia(e), e.fechaFinTorneo);
const haTerminado = (e: TorneoPropioDTO) => !!primerDia(e) && ultimoDia(e) < diaDeHoy();
const estaEnCurso = (e: TorneoPropioDTO) => !!primerDia(e) && primerDia(e) <= diaDeHoy() && !haTerminado(e);

const fechas = (e: TorneoPropioDTO) => {
  const inicio = primerDia(e);
  if (!inicio) return "Sin fecha";
  const fin = ultimoDia(e);
  return fin > inicio
    ? `Del ${formatFechaSpaWhitoutAsync(inicio)} al ${formatFechaSpaWhitoutAsync(fin)}`
    : formatFechaSpaWhitoutAsync(inicio);
};
const tipo = (e: TorneoPropioDTO) => tipoTorneoOptions.find(t => t.value === e.tipoTorneo)?.label ?? e.tipoTorneo;

// Próximos: primero el que antes empieza. Terminados: primero el que acabó más tarde
const proximos = computed(() =>
  eventos.value.filter(e => !haTerminado(e)).sort((a, b) => primerDia(a).localeCompare(primerDia(b)))
);
const terminados = computed(() =>
  eventos.value.filter(e => haTerminado(e)).sort((a, b) => ultimoDia(b).localeCompare(ultimoDia(a)))
);
const lista = computed(() => (vista.value === "proximos" ? proximos.value : terminados.value));
const visibles = computed(() => lista.value.slice(0, cuantosVer.value));
watch(vista, () => (cuantosVer.value = TANDA));

// Cada formato tiene su gestión
const rutaGestion = (e: TorneoPropioDTO) => {
  const params = { idTorneo: e.idTorneo };
  if (esPorJornadas(e.formatoTorneo))
    return {
      name: e.formatoTorneo === FORMATO_COPA ? "detalle-torneo-gestion-copa" : "detalle-torneo-gestion-liga",
      params,
    };
  if (e.tipoTorneo !== "Individual") return { name: "detalle-torneo-gestion-equipos", params };
  if (e.listasPorJugador > 1) return { name: "detalle-torneo-gestion-individual-mas", params };
  return { name: "detalle-torneo-gestion", params };
};

const cargar = async () => {
  try {
    const response = await getTorneosCreadosUsuario(String(idUsuario));
    eventos.value = response.data;
    // Sin eventos próximos, se empieza por los terminados
    if (proximos.value.length === 0 && terminados.value.length > 0) vista.value = "terminados";
  } catch (error) {
    console.error("Error recuperando los eventos creados por el usuario:", error);
  } finally {
    isLoading.value = false;
  }
};

const alCrear = async () => {
  crear.value = false;
  vista.value = "proximos";
  await cargar();
};

const aBorrar = ref<TorneoPropioDTO | null>(null);
const borrando = ref(false);
const pedirBorrado = (evento: TorneoPropioDTO) => (aBorrar.value = evento);
const borrar = async () => {
  if (!aBorrar.value) return;
  const evento = aBorrar.value;
  borrando.value = true;
  try {
    await deleteTorneo(evento.idTorneo);
    eventos.value = eventos.value.filter(e => e.idTorneo !== evento.idTorneo);
    triggerToast("success", `Se ha borrado ${textosEvento(evento.formatoTorneo).el}`);
  } catch (error) {
    console.error("Error borrando el evento:", error);
    triggerToast("error", `No se ha podido borrar ${textosEvento(evento.formatoTorneo).el}`);
  } finally {
    borrando.value = false;
    aBorrar.value = null;
  }
};

onMounted(cargar);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingGandalf)
        ]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          class: "gestion text-left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              class: "mb-3 mx-auto d-flex crear",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (crear.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Crear evento ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_chip_group, {
              modelValue: vista.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vista).value = $event)),
              mandatory: "",
              column: "",
              "selected-class": "text-primary",
              class: "mb-2 fichas"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  value: "proximos",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Próximos y en curso (" + _toDisplayString(proximos.value.length) + ")", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_chip, {
                  value: "terminados",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Terminados (" + _toDisplayString(terminados.value.length) + ")", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (lista.value.length === 0)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  variant: "outlined",
                  class: "pa-4 text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(vista.value === "proximos"
            ? "No organizas ningún evento próximo. Crea uno con «Crear evento»."
            : "Aún no ha terminado ningún evento tuyo."), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (evento) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: evento.idTorneo,
                        cols: "12",
                        sm: "6",
                        lg: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            variant: "outlined",
                            class: "pa-3 h-100",
                            link: "",
                            onClick: ($event: any) => (_unref(router).push(rutaGestion(evento)))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(evento.nombreTorneo), 1),
                                (estaEnCurso(evento))
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "x-small",
                                      color: "success",
                                      variant: "tonal",
                                      class: "flex-shrink-0 mt-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" En curso ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  icon: "mdi-trash-can-outline",
                                  variant: "text",
                                  size: "small",
                                  density: "comfortable",
                                  color: "error",
                                  class: "flex-shrink-0 mt-n1",
                                  "aria-label": `Borrar ${evento.nombreTorneo}`,
                                  onClick: _withModifiers(($event: any) => (pedirBorrado(evento)), ["stop"])
                                }, null, 8, ["aria-label", "onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_5, _toDisplayString(fechas(evento)) + " · " + _toDisplayString(_unref(nombreEvento)(evento.formatoTorneo)) + " · " + _toDisplayString(tipo(evento)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
            (lista.value.length > visibles.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (cuantosVer.value += TANDA))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver más (" + _toDisplayString(lista.value.length - visibles.value.length) + ") ", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    _createVNode(ModalCrearTorneo, {
      isVisible: crear.value,
      idUsuario: _unref(idUsuario),
      onClose: _cache[3] || (_cache[3] = ($event: any) => (crear.value = false)),
      onConfirm: alCrear
    }, null, 8, ["isVisible", "idUsuario"]),
    _createVNode(_component_v_dialog, {
      "model-value": !!aBorrar.value,
      persistent: borrando.value,
      "max-width": "420",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (aBorrar.value = null))
    }, {
      default: _withCtx(() => [
        (aBorrar.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ¿Borrar " + _toDisplayString(_unref(textosEvento)(aBorrar.value.formatoTorneo).el) + "? ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Se borrará "),
                    _createElementVNode("strong", null, _toDisplayString(aBorrar.value.nombreTorneo), 1),
                    _createTextVNode(". No se puede deshacer. ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      disabled: borrando.value,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (aBorrar.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      variant: "tonal",
                      loading: borrando.value,
                      onClick: borrar
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Borrar")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value", "persistent"])
  ], 64))
}
}

})